import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { useLocation, useNavigate } from 'react-router-dom'
import ROUTES from '@/routes/routes'

const QrVerification: React.FC = () => {
  const location = useLocation()

  const navigate = useNavigate()
  const { qrCode } = location.state || {}

  const handleSkip = () => {
    navigate(ROUTES.PROFESSOR.ROOMS)
  }

  return (
    <div className='flex h-screen w-screen flex-col md:flex-row'>
      <div className='relative hidden flex-1 md:block'>
        <img
          src='/images/auth-background.svg'
          alt='Auth background'
          className='absolute w-1/2 object-cover md:h-full md:w-5/6'
        />
        <div className='flex h-full items-center justify-center'>
          <img
            src='/images/auth-avatar.svg'
            alt='Auth Avatar'
            className='absolute z-10 object-contain md:h-full md:w-auto'
          />
        </div>
      </div>
      <div className='flex flex-1 flex-col items-center justify-center'>
        <div className='flex justify-center'>
          <img
            src='/images/oge.svg'
            alt='Huble logo'
            className='w-1/2 object-contain md:w-full'
          />
        </div>
        <div className='flex w-3/4 flex-col items-center md:w-full'>
          <Card className='w-full max-w-md border-none shadow-none'>
            <CardHeader className='space-y-1 flex flex-col items-center'>
              <CardTitle className='text-4xl font-bold leading-[50px]'>
                QR Verification
              </CardTitle>
              <CardDescription className='text-base text-black font-normal text-center'>
                Scan the QR code below to verify your account.
              </CardDescription>

              {qrCode ? (
                <img
                  src={`data:image/png;base64,${qrCode}`}
                  alt='QR Code'
                  className='w-56 h-56 object-cover mb-1 md:w-64 md:h-64 lg:w-72 lg:h-72'
                />
              ) : (
                <p>No QR code available</p>
              )}
            </CardHeader>
            <CardContent className='space-y-4'>
              <Button
                onClick={handleSkip}
                className='w-full h-[38px] text-base font-normal bg-dark-blue hover:bg-dark-blue-hovered'
              >
                Skip
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default QrVerification
